import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/user/emailDuplicate/user.emailDuplicate.query.gql"
import type {
  UserEmailDuplicateQuery,
  UserEmailDuplicateQueryVariables,
} from "@/v2-backoffice-client/user/emailDuplicate/__types__/user.emailDuplicate.query"

type Options = QueryHookOptions<
  UserEmailDuplicateQuery,
  UserEmailDuplicateQueryVariables
>

export function useUserEmailDuplicateQuery(options?: Options) {
  return useQuery<UserEmailDuplicateQuery, UserEmailDuplicateQueryVariables>(
    query,
    options,
  )
}
